import {
  collection,
  query,
  where,
  getDocs,
  CollectionReference,
  orderBy,
  QueryConstraint,
  limit,
} from 'firebase/firestore'
import medicalReimbursementServiceConfigs from './configs'
import { db } from '../../firebase/firebase'
import { ApprovalStatus } from '../../database/enums/ApprovalStatus.enum'
import constants from '../../constants'
import { MedicalReimbursement, MedicalReimbursementRaw } from '../../database/tables'
import MedicalReimbursementTableHelper from '../../database/tables/helpers/medical-reimbursement.helper'

export default async function getRespondedMedicalReimbursements(): Promise<MedicalReimbursement[]> {
  return new Promise(async (resolve, reject) => {
    try {
      const constraints: QueryConstraint[] = [
        where('approvalStatus', '!=', ApprovalStatus.UNRESPONDED),
        orderBy('createdAt', 'desc'),
        limit(constants.limits.fetchDataCount.md),
      ]

      const currCollection = collection(
        db,
        medicalReimbursementServiceConfigs.collectionName,
      ) as CollectionReference<MedicalReimbursementRaw>
      const q = query(currCollection, ...constraints)
      const querySnapshot = await getDocs(q)

      const results: any[] = []
      querySnapshot.forEach(doc => {
        results.push(MedicalReimbursementTableHelper.fromRaw({ id: doc.id, rawData: doc.data() }))
      })

      return resolve(results)
    } catch (e) {
      return reject(e)
    }
  })
}
